import { withFormik } from 'formik'
import { compose, lifecycle, withHandlers, withStateHandlers } from 'recompose'

import {required, validEmail, passwordIsInvalid, validFullName, samePassword} from 'utils/validation'
import {FORM_ACTION_ERROR_STATUS, FORM_PROGRESS_STATUS, FORM_SUBMIT_STATUS} from 'constants/form'

export default compose(
  withFormik({
    // Transform outer props into form values
    mapPropsToValues: () => ({
      email: '', name: '', password: '', confirmPassword: '' 
    }),
    // Add a custom validation function (this can be async too!)
    validate: ({
      email, name, password, confirmPassword 
    }) => {
      const errors = {}

      if (required(email)) {
        errors.email = 'Please enter an email for your account'
      }
      else if (!validEmail(email)) {
          errors.email = 'Please enter a valid email'
      }

        if (required(name)) {
            errors.name = 'Please enter your account name'
        }
        else if (validFullName(name)) {
            errors.name = 'You must enter a first and a last name'
        }

        if (required(password) || passwordIsInvalid(password)) {
            errors.password = 'Your password must have a minimum of eight characters.'
            errors.confirmPassword = ''
        }

        if (samePassword(password, confirmPassword)) {
            errors.password = 'These passwords do not match'
            errors.confirmPassword = 'These passwords do not match'
        }

        return errors
    },
    enableReinitialize: true,
    validateOnChange: false,
    handleSubmit: (values, {
      props, setSubmitting,
    }) => {
      setSubmitting(true)
      // If form has no error
      if (props.onCreateSubmit) {
        props.onCreateSubmit(values)
      }
    // props.actions.loginUser(values)
    },
  }),
  withStateHandlers(
    () => ({
      showPassword: false,
      showConfirmPassword: false
    }),
    {
      togglePasswordVisibility: state => () => ({
        showPassword: !state.showPassword
      }),
      toggleConfirmPasswordVisibility: state => () => ({
        showConfirmPassword: !state.showConfirmPassword
      })
    }
  ),
  // Handlers
  withHandlers({
    handleFieldChange: props => (event) => {
    // test
      props.setStatus(FORM_PROGRESS_STATUS)
      props.handleChange(event)
    },
    handleFormSubmit: props => (event) => {
      props.setStatus(FORM_SUBMIT_STATUS)
      props.handleSubmit(event)
    },
    hasFieldError: props => (fieldName) => {
      return !!((props.errors[fieldName] && props.errors[fieldName].length && props.status === FORM_SUBMIT_STATUS))
    },
  }),
  lifecycle({
    componentDidUpdate(prevProps) {
      const {
        apiCallError, setStatus, setSubmitting
      } = this.props
      // trigger when error occured during login
      if (prevProps.apiCallError !== apiCallError && apiCallError) {
        setStatus(FORM_ACTION_ERROR_STATUS)
        setSubmitting(false)
      }
    },

  })
)




// WEBPACK FOOTER //
// ./src/components/organisms/CreateAccountForm/CreateAccountForm.enhancer.js